import React, { Fragment } from 'react';
import autoBind from 'react-autobind';
import { AutoComplete } from '@progress/kendo-react-dropdowns';
import { Row, Col, FormGroup, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import _ from 'lodash';
import { StyledDivDropdown, StyledDropdown } from './dropdownDiv.component.styles';

class SuggestionComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: '',
      isOpen: false,
      isLoading: false,
      pageSize: 10,
      dataCount: 10,
      options: [],
      timeoutId: null,
      isInputDisabled: false,
    };

    this.divDropdownRef = React.createRef();
    this.handleClickOutsideDropdown = this.handleClickOutsideDropdown.bind(this);

    autoBind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      (JSON.stringify(nextProps.value) != JSON.stringify(this.props.value) || !this.state.selectedValue) &&
      !this.timeout
    ) {
      const newValue = _.isString(nextProps.value)
        ? nextProps.value
        : nextProps.value[nextProps.labelKey || 'Exibicao'];
      if (newValue != this.state.selectedValue) {
        this.setState({
          selectedValue: newValue?.replace('\n', ' ') || '',
          isOpen: false,
          isLoading: false,
        });
      }
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutsideDropdown);

    if (this.props.allowCustom && this.props.maxLength) this.autoComplete._input.maxLength = this.props.maxLength;

    this.handleApi = _.debounce(this.handleApi, 800);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutsideDropdown);
  }

  handleClickOutsideDropdown(event) {
    const { Linhas } = this.props;
    if (!this.divDropdownRef?.current?.contains(event.target) && this.state.isOpen && Linhas > 0)
      this.setState({ isOpen: false });
  }

  mapItem(value) {
    const { mapItem, labelKey } = this.props;

    const item = mapItem(value);
    return { ...item, [labelKey || 'Exibicao']: item[labelKey || 'Exibicao']?.replace('\n', ' ') };
  }

  async handleApi(value) {
    const { onChange, labelKey } = this.props;
    const { options, timeoutId } = this.state;

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    let selectedItem = options.find((x) => this.mapItem(x)[labelKey || 'Exibicao'] == value);
    if (value && !selectedItem && this.props.allowCustom) selectedItem = value;
    onChange && onChange(selectedItem);

    const novoIdTimeout = setTimeout(async () => {
      if (
        value &&
        value.toString().trim() !== '' &&
        (!selectedItem || this.props.allowCustom) &&
        typeof selectedItem !== 'object'
      ) {
        const { service, parameters } = this.props;
        this.setState({ isLoading: true, isInputDisabled: true });
        try {
          const response = await service(value, parameters);
          const { dataList, dataCount } = response.data;
          this.setState({
            isOpen: true,
            isLoading: false,
            isInputDisabled: false,
            options: dataList.map(this.mapItem),
            dataCount,
          });
        } catch (error) {
          this.setState({ isLoading: false, isInputDisabled: false });
          console.error('Erro ao chamar o serviço:', error);
        }
      } else {
        this.setState({ isLoading: false, isInputDisabled: false });
      }
    }, 300);

    this.setState({ timeoutId: novoIdTimeout });
  }

  async handleSearch(event) {
    const { value } = event.target;

    await this.setState({
      selectedValue: value,
      isLoading: true,
      isOpen: false,
    });

    await this.handleApi(value);
  }

  onBlurCloseAutoComplete() {
    this.setState({ isOpen: false });

    this.props.onBlur && this.props.onBlur();
  }

  onSelectItem(item) {
    const { onChange } = this.props;

    this.setState({
      isOpen: false,
      selectedValue: item.Exibicao,
    });

    onChange && onChange(item);
  }

  getExibicao(item) {
    const { ExibeDescricao, LimiteCaracteres } = this.props;
    const texto = ExibeDescricao ? item.Descricao : item.Exibicao;

    if (!(LimiteCaracteres > 0)) return texto;

    if (texto?.length >= LimiteCaracteres) return `${texto.substring(0, LimiteCaracteres)}...`;
    else return texto;
  }

  render() {
    const { placeholder, disabled, className, name, labelKey, title, Linhas, isView } = this.props;
    const { isLoading, isOpen, options, selectedValue, dataCount, isInputDisabled } = this.state;

    return (
      <Row className="margin-bottom-offset-suggestion">
        <Col>
          <OverlayTrigger
            key={'top'}
            placement={'top'}
            overlay={
              !isView && (
                <Tooltip id={`tooltip-top`}>
                  <div className={'fontTooltip'}>{title}</div>
                </Tooltip>
              )
            }
          >
            <FormGroup>
              <Fragment>
                {!(Linhas & (Linhas > 0)) ? (
                  <AutoComplete
                    style={{ border: 0 }}
                    ref={(t) => (this.autoComplete = t)}
                    data={options}
                    title={title}
                    loading={isLoading}
                    opened={isOpen}
                    name={name}
                    value={selectedValue}
                    className={className}
                    disabled={disabled || isInputDisabled}
                    textField={labelKey || 'Exibicao'}
                    onBlur={this.onBlurCloseAutoComplete}
                    onChange={this.handleSearch}
                    placeholder={placeholder}
                    listNoDataRender={() => null}
                    popup={{
                      height: 300,
                    }}
                    footer={
                      <Dropdown.Item disabled={true} style={{ paddingLeft: 13 }}>
                        Mostrando {options.length} de {dataCount} registros.
                      </Dropdown.Item>
                    }
                  />
                ) : (
                  <div>
                    <textarea
                      rows={Linhas}
                      value={selectedValue}
                      className={'form-control'}
                      disabled={disabled}
                      onChange={this.handleSearch}
                      placeholder={placeholder}
                    />
                    <StyledDivDropdown hidden={!isOpen} ref={this.divDropdownRef}>
                      <StyledDropdown key={`multipleActions-${title}`} className="dropdown">
                        {options.map((item) => (
                          <Dropdown.Item key={item.Id} onClick={() => this.onSelectItem(item)}>
                            {this.getExibicao(item)}
                          </Dropdown.Item>
                        ))}
                        <Dropdown.Item disabled={true} style={{ paddingLeft: 13 }}>
                          Mostrando {options.length} de {dataCount} registros.
                        </Dropdown.Item>
                      </StyledDropdown>
                    </StyledDivDropdown>
                  </div>
                )}
                <span hidden={disabled} className="form-control-feedback add-on-suggestion">
                  {isLoading ? (
                    <i className="fa fa-spinner fa-spin" />
                  ) : (
                    <i className={`${this.props.allowCustom === true ? 'fa fa-comment-medical' : 'fa fa-comment'}`} />
                  )}
                </span>
              </Fragment>
            </FormGroup>
          </OverlayTrigger>
        </Col>
      </Row>
    );
  }
}

SuggestionComponent.defaultProps = {
  allowCustom: false,
};

export default SuggestionComponent;
